import { Link, NavLink } from "react-router-dom";
import { ChevronsLeft, ChevronsRight, LogOut } from "lucide-react";
import formulaMark from "../../assets/brand/logo.png";

export function Sidebar({ navItems, brandTitle, brandSubtitle, open, isDesktop, onToggle, onLinkClick, onSignOut, sidebarRef }) {
  return (
    <aside ref={sidebarRef} id="ops-sidebar" className={`ops-sidebar ${open ? "is-open" : "is-collapsed"}`} aria-hidden={!isDesktop && !open ? "true" : undefined} inert={!isDesktop && !open ? "" : undefined}>
      <div className="ops-sidebar-header">
        <Link to="/" className="ops-brand" aria-label={brandTitle}>
          <img src={formulaMark} alt="" className="ops-brand-logo" />
          {/* <div className="ops-brand-copy">
            <p className="ops-brand-subtitle">{brandSubtitle}</p>
          </div> */}
        </Link>
        <button
          type="button"
          className="ops-sidebar-toggle"
          onClick={onToggle}
          aria-label={isDesktop ? (open ? "Collapse sidebar" : "Expand sidebar") : "Close navigation"}
        >
          {open ? <ChevronsLeft size={16} /> : <ChevronsRight size={16} />}
        </button>
      </div>

      <nav className="ops-sidebar-nav" aria-label="Primary navigation">
        {navItems.map(({ label, path, icon: Icon, end }) => (
          <NavLink
            key={path}
            to={path}
            end={end}
            className={({ isActive }) => `ops-sidebar-item ${isActive ? "is-active" : ""}`}
            onClick={onLinkClick}
            title={label}
          >
            <Icon size={18} strokeWidth={1.8} className="ops-sidebar-item-icon" />
            <span className="ops-sidebar-item-text">{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="ops-sidebar-footer">
        <button type="button" className="ops-sidebar-signout" onClick={onSignOut} title="Sign out">
          <LogOut size={18} strokeWidth={1.8} />
          <span className="ops-sidebar-item-text">Sign out</span>
        </button>
      </div>
    </aside>
  );
}
